module.exports = __webpack_public_path__ + "static/img/code1.a890c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/code1.png
// module id = bWU6
// module chunks = 0